
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import Breadcrumb from './breadcrumb'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "breadcrumb"
    }}>{`Breadcrumb`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Navigation`}</p>
    <hr />
    <h2 {...{
      "id": "breadcrumb-1"
    }}>{`Breadcrumb`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`Wayfinding links for transversing a hierarchy of content.`}</p>
    <Playground __position={1} __code={'<Breadcrumb\n  items={[\n    { name: \'Path\', href: \'/\', id: \'1\' },\n    { name: \'Path\', href: \'/\', id: \'2\' },\n    { name: \'Path\', href: \'/\', id: \'3\' },\n    { name: \'Current\', href: \'/\', id: \'4\' },\n  ]}\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Breadcrumb
    }} mdxType="Playground">
  <Breadcrumb items={[{
        name: 'Path',
        href: '/',
        id: '1'
      }, {
        name: 'Path',
        href: '/',
        id: '2'
      }, {
        name: 'Path',
        href: '/',
        id: '3'
      }, {
        name: 'Current',
        href: '/',
        id: '4'
      }]} mdxType="Breadcrumb" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={Breadcrumb} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;